<template>
    <div class="carousel">
        <div v-if="userBgStyle" class="carousel__user">
            <div class="carousel__logo-container">
                <div :style="pageLogoStyle" class="carousel__logo-content"> </div>
            </div>
            <div class="carousel-user-bg" :style="userBgStyle"> </div>
        </div>
        <div class="carousel__patsnap" v-else>
            <img alt="Logo" class="carousel__logo" :src="pageLogo" />
            <div class="swiper-slide" v-if="imageBannerData">
                <div class="swiper__item">
                    <img class="carousel__product-img" :src="imageBannerData.image" :alt="imageBannerData.name" />
                    <div class="carousel__product-logo-container">
                        <img :src="getProductLogo(imageBannerData.id)" :alt="imageBannerData.name"/>
                    </div>
                    <p class="carousel__product-info" v-html="imageBannerData.info"></p>
                </div>
            </div>

            <!-- Slider main container -->
            <div class="swiper" v-else>
                <!-- Additional required wrapper -->
                <div class="swiper-wrapper">
                    <!-- Slides -->
                    <div class="swiper-slide" v-for="item in productInfos" :key="item.name">
                        <div class="swiper__item" v-lazy-container="{ selector: 'img', error:'', loading:'' }">
                            <img class="carousel__product-img" :data-src="item.image" :alt="item.name" data-loading="" />
                            <div>
                                <div class="carousel__product-logo-container" v-if="getProductLogo(item.id)">
                                    <img height="24" :data-src="getProductLogo(item.id)" v-if="getProductLogo(item.id)" :alt="item.name" data-loading=""/>
                                </div>
                                <p class="carousel__product-info" v-html="item.info"></p>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- If we need pagination -->
                <div class="swiper-pagination"></div>

                <!-- If we need navigation buttons -->
                <div class="swiper-button-prev"></div>
                <div class="swiper-button-next"></div>

                <!-- If we need scrollbar -->
                <div class="swiper-scrollbar"></div>
            </div>
        </div>
    </div>
</template>
<script >
import _ from 'lodash';
import LogoPatsnap from '../../assets/logo-patsnap.png';
import { getVar } from 'library-components/utils/environment';
import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

function isWebPSupportedFn() {
    try {
        return document.createElement('canvas').toDataURL('image/webp', '').indexOf('data:image/webp') === 0;
    } catch (error) {
        console.log(error);
    }
    return false
}

const PRODUCT_COMPONENTS = {
    help_center: 'help_center',
    analytics: 'analytics',
    discovery: 'discovery',
    lifescience: 'bio',
    chemical: 'chemical',
    synapse: 'synapse',
    insights: 'insights',
    inno: 'innosnap',
    course2b: 'course2b',
    academy: 'academy',
    tffi: 'tffi',
    eureka: 'eureka',
    innocloud: 'innocloud',
    yunchuang: 'yunchuang',
    community: 'community',
    ls360: 'ls360',
};

export default {
    data() {
        return {
            productInfos: [],
            pageLogo: LogoPatsnap,
            userBgStyle: null,
            pageLogoStyle: null,
            InitialIndex: 0,
        };
    },
    inject: ['commonService'],
    computed: {
        productList() {
            let productList = ['help_center', 'public_pages', 'analytics', 'discovery', 'chemical', 'lifescience', 'synapse',
                ...this.commonService.IsRegionUS ? ['ls360'] : [],
                'academy', 'eureka', 'community'];
            if (this.commonService.IsRegionCN) {
                productList = ['public_pages', 'analytics', 'discovery', 'chemical', 'lifescience', 'synapse', 'ls360', 'eureka', 'tffi', 'innocloud', 'yunchuang'];
            }
            return productList;
        },
        imageBannerData() {
            const banner_type = getVar('banner_type');
            if (banner_type === 'image') {
                return this.productInfos[this.InitialIndex];
            }
            return null;
        },
        openWhiteLabel() {
            const whiteLabelTags = ['HIGH', 'LOW'];
            const { white_label, company_background } = _.get(this.commonService, 'globalData');
            return _.includes(whiteLabelTags, white_label) && company_background;
        },
        globalData() {
            return _.get(this.commonService, 'globalData');
        },
    },
    watch: {
        globalData() {
            this.initUserLoginData();
        },
    },
    methods: {
        initUserLoginData(val) {
            const { company_background, company_logo } = _.get(this.commonService, 'globalData');
            if (this.openWhiteLabel) {
                if (company_logo) {
                    this.pageLogo = company_logo;
                    this.pageLogoStyle = {
                        backgroundSize: 'contain',
                        backgroundImage: `url(${company_logo})`,
                    };
                }
                if (company_background) {
                    this.userBgStyle = {
                        backgroundSize: 'cover',
                        backgroundImage: `url(${company_background})`,
                    };
                }
            } else {
                this.initProductInfos();
            }
        },
        initProductInfos() {
            const isWebPSupported = isWebPSupportedFn()
            this.productInfos = _.map(this.productList, item => {
                return {
                    id: item,
                    name: this.$t(`passport.products.${item}`),
                    image: require(`../../assets/products/_${item}.${isWebPSupported ? 'webp' : 'png'}`),
                    info: this.$t(`passport.products_info.${item}`),
                };
            });
            this.initCarouselIndex();
        },
        initCarouselIndex() {
            const from = getVar('from');
            if (from) {
                const index = this.productList.indexOf(from);
                if (index !== -1) {
                    this.InitialIndex = index;
                } else {
                    this.InitialIndex = this.productList.indexOf('public_pages');
                }
            }
        },
        getProductLogo(id) {
            const locale = this.$i18n.locale === 'cn' ? 'cn' : 'en';
            const img = `${PRODUCT_COMPONENTS[id]}_${locale}`;
            try {
                return require(`library-components/assets/images/logo/${img}.svg`);
            } catch (error) {
                return '';
            }
        },

    },
    created() {
        this.initUserLoginData();

        this.$nextTick(() => {
            // eslint-disable-next-line
            const swiper = new Swiper('.swiper', {
                loop: true,
                modules: [Navigation, Pagination, Autoplay],
                autoplay: {
                    delay: 2500,
                    disableOnInteraction: false,
                },
                // If we need pagination
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                },
                initialSlide: this.InitialIndex,

                // Navigation arrows
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },

                // And if we need scrollbar
                scrollbar: {
                    el: '.swiper-scrollbar',
                },
            });
        })
    },
};
</script>
<style lang="scss">
.carousel {
    background-color: #f5f5f5;
    height: 100%;
    position: relative;
    .carousel-user-bg{
        width: 100%;
        height: 100%;
    }
    &__user, &__patsnap{
        width: 100%;
        height: 100%;
    }
    &__logo-container{
        z-index: 10;
        position: absolute;
        left: 24px;
        top: 16px;
        background: #fff;
        padding: 4px 12px;
        border-radius: 20px;
    }
    &__logo-content{
        width: 108px;
        height: 32px;
        background-repeat: no-repeat;
        background-position: center center;
    }
    &__logo {
        z-index: 10;
        width: 108px;
        position: absolute;
        left: 24px;
        top: 16px;
    }
    .swiper__item {
        display: flex;
        justify-content: space-between;
        flex-direction: column;
        padding: 50px 84px 0 84px;
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        align-items: center;
        .carousel__product-img {
            display: block;
            height: auto;
            flex: 0 0 auto;  /* IE */
            object-fit: scale-down;
            width: 100%;
            margin-left: 0;
            margin-top: auto;
            margin-bottom: auto;
        }
        .carousel__product-name {
            color: #535353;
            font-size: 24px;
            margin-top: 0;
            margin-bottom: 8px;
        }
        .carousel__product-info {
            color: #707070;
            width: 100%;
            font-size: 14px;
            line-height: 20px;
            margin-bottom: 100px;
            text-align: center;
        }
        .carousel__product-logo-container{
            margin-bottom: 20px;
            height: 28px;
            text-align: center;
            img {
                height: 28px;
            }
        }
    }
    .el-carousel__indicators {
        bottom: 0;
    }
    .el-carousel__indicator {
        padding-left: 3px;
        padding-right: 3px;
        .el-carousel__button {
            background-color: #1fa500;
            width: 6px;
            height: 6px;
            border-radius: 3px;
        }
        &.is-active {
            .el-carousel__button {
                background-color: #1fa500;
                width: 16px;
            }
        }
    }
}

swiper-container {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
}

.swiper-slide {
    text-align: center;
    font-size: 18px;
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;

}

.swiper {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
}

.swiper-pagination-bullet {
    background: #45A321;
}
.swiper-pagination-bullet {
    width: 6px;
    height: 6px;
    opacity: 0.5;
}
.swiper-pagination-bullet-active {
    width: 16px;
    border-radius: 8px;
    background: #45A321;
    opacity: 1;
}
.swiper-button-next, .swiper-button-prev {
    display: none;
    height: 36px;
    width: 36px;
    transition: .3s;
    border-radius: 50%;
    background-color: rgba(31,45,61,.11);
    cursor: pointer;
    &::after {
        color: #fff;
        font-size: 12px;
    }
}
.swiper:hover {
    .swiper-button-next, .swiper-button-prev {
            display: flex;
    }
}

@media (max-width: 820px) {
    .carousel {
        background: linear-gradient(42.15deg, #F6F9FF 8.5%, #F8FFFA 91.31%);
        &__logo {
            display: none;
        }
        .swiper__item {
            flex-direction: row-reverse;
            padding: 0;
            width: 336px;
            height: auto;
            .carousel__product-img {
                width: 107px;
                height: 83px;
                margin-left: 6px;
            }

            .carousel__product-info {
                font-size: 10px;
                line-height: 14px;
                margin-bottom: 0;
                text-align: left;
                color: #8993A4;
            }
            .carousel__product-logo-container{
                margin-bottom: 6px;
                height: 20px;
                text-align: left;
                img {
                    height: 20px;
                }
            }
        }
    }

    .swiper-horizontal>.swiper-pagination-bullets, .swiper-pagination-bullets.swiper-pagination-horizontal {
        bottom: 2px;
    }

    .swiper-pagination-bullet {
        width: 4px;
        height: 4px;
    }
    .swiper:hover {
        .swiper-button-next, .swiper-button-prev {
            display: none;
        }
    }
}

</style>
